import { combineReducers } from 'redux';
import settingsReducer from './settings';
import reservationReducer from './reservation';
import orderReducer from './order';
import uiReducer from './ui';
import feedbacksReducer from './feedbacks';


export default combineReducers({
    settingsReducer,
    reservationReducer,
    orderReducer,
    uiReducer,
    feedbacksReducer,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js